import { render, staticRenderFns } from "./TopElementUserBar.vue?vue&type=template&id=feeb4044&scoped=true&"
import script from "./TopElementUserBar.vue?vue&type=script&lang=js&"
export * from "./TopElementUserBar.vue?vue&type=script&lang=js&"
import style0 from "./TopElementUserBar.vue?vue&type=style&index=0&id=feeb4044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feeb4044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
